"use client";

import { FiChevronRight } from "react-icons/fi";
import { HeroModule } from "@/components/HeroModule";
import { FixItModule, FixItProps } from "@/components/FixItModule";
import { AboutScanToolModule, AboutScanToolProps } from "@/components/AboutScanToolModule";
import { FAQScanModule, FAQScanProps } from "@/components/FAQScanModule";
import { AnalyticsBannerModule } from "@/components/AnalyticsBannerModule";
import { analyticsBannerProps, billboardProps } from "@/data/types/home";

import "./styles.scss";

interface QrcreatorDevScanToolTemplateProps {
  data: {
    billboard?: billboardProps;
    fixIt?: FixItProps;
    about: AboutScanToolProps;
    faqs: FAQScanProps;
    supportLabel: string;
    bottomBanner: analyticsBannerProps;
  };
}

export const QrcreatorDevScanToolTemplate = ({ data }: QrcreatorDevScanToolTemplateProps) => {
  return (
    <main className="qrcreator-dev-scan-template">
      {data.billboard && <HeroModule data={data.billboard} />}
      {data.fixIt && <FixItModule data={data.fixIt} />}
      {data.about && <AboutScanToolModule data={data.about} />}
      {data.faqs && (
        <FAQScanModule
          data={data.faqs}
          supportLabel={data.supportLabel}
        />
      )}
      {data.bottomBanner && (
        <AnalyticsBannerModule data={{ ...data.bottomBanner, ctaIcon: <FiChevronRight /> }} />
      )}
    </main>
  );
};
